import React, { Component } from 'react'
import { connect } from 'react-redux'

// import '@/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-left.scss'
import SearchIcon from '@/assets/images/icons/nav_icon_search.png';
import RefreshIcon from '@/assets/images/icons/icon_refresh_gray.png';

import Dropdown from '@/components/Dropdown/Dropdown';
import Input from '@/companys/ttl/components/Input'

import { INDEX_KEY } from '@/constants/keys.code';
import { dataType } from '@/constants/data-type';
import { Icons, SERVICES_RESP, history } from '@/configurations';
import { PARAMS } from '@/constants/params';

import { Converter, formatFunctions, utilsFunction } from '@/helpers/functions';
import { forumActions } from '@/actions/forum';
import { stockActions } from '@/actions/trading/stock.action';

class VirtualTradingAreaLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSearchBlock: false,
            searchList: [],
            currentMarket: 'HKEX',
            currentStock:'00001'
        }
    }
    render() {
        const { language, lotSize, markets  } = this.props
        const { searchList ,showSearchBlock} = this.state
        return (
            <div className='virtual-trading-area-left'>
                <div className='vta-centent-left'>
                    <span className='vta-centent-left-stock'>
                        {'HK.00001   CKH HOLDINGS'}
                    </span>
                    <div className='vta-centent-left-number' >
                        <span className='number-quote' >{'34.400'}</span>
                        <span className='number-updown' >{'+15.000 (+21.50%)'} </span>
                    </div>
                    <div className='vta-stock' >
                        <div className='vta-stock-search' >
                            <Dropdown
                                selectedOptions={[markets[0]]}
                                options={markets}
                                onChange={this.handleChangeMarket}
                            />
                            <div className='vta-stock-input'>
                                <img src={SearchIcon} className='input-icon' />
                                <div className='vta-stock-input-div' >
                                    <input
                                        autocomplete="off"
                                        onInput={this.handleSearchInput} />
                                </div>
                                <img src={RefreshIcon} className='refresh-icon' />
                            </div>
                        </div>
                        {showSearchBlock && <div className='input-search'>
                            {searchList?.map((item, index) => {
                                return (
                                    <div className='input-search-single' key={item.id}  onClick={()=>this.handleSelectStock(item.id)} >
                                        <span className='input-search-single-stock' >{item.market + '.' + item.id}</span>
                                        <span className='input-search-single-name' > {item.name} </span>
                                    </div>
                                )
                            })}
                        </div>}
                    </div>
                    <div className='vta-price'>
                        <span>{language.common_price}</span>
                        <div className='price' >
                            <Input
                                innerRef={e => this.priceRef = e}
                                step={0.001}
                                dataType={dataType.CURRENCY} />
                        </div>
                    </div>
                    <div className='vta-quantity'>
                        <span>{language.common_quantity} </span>
                        <div className='quantity'>
                            <Input
                                innerRef={e => this.quantityRef = e}
                                step={1}
                                dataType={dataType.NUMBER} />
                        </div>
                    </div>
                    <div className='vta-power'>
                        <span>{language.common_buying_power} </span>
                        <span>{'123.255.65'} </span>
                    </div>
                    <div className='vta-amount' >
                        <span>{language.place_order_dialog_gross_amount} </span>
                        <span> {'15,351.00'} </span>
                    </div>
                    <div className='vta-button'>
                        <div className='vta-button-buy'> {language.virtual_trading_buy} </div>
                        <div className='vta-button-sell'> {language.virtual_trading_sell} </div>
                    </div>
                </div>
            </div>
        )
    }
    componentDidMount() {
        this.setState({ currentMarket: this.props.markets[0]?.value })
    }
    handleSelectStock = (stockId) =>{
        const {currentMarket} = this.state
        const {language} = this.props
        this.setState({showSearchBlock:false,currentStock:stockId},()=>{
            const params = {
                [PARAMS.MARKET_ID]: currentMarket,
                [PARAMS.INSTRUMENT_ID]: this.state.currentStock.trim(),
                [PARAMS.LANGUAGE]: language.lang
              }
              this.props.getQuote({exchangeID:currentMarket,instrumentID:this.state.currentStock.trim()},res=>{
              })
              this.props.getInstrumentDetail(params,res=>{
              })
        })
    }
    handleChangeMarket = (market) => {
        this.setState({ currentMarket: market[0].value })
    }
    handleSearchInput = utilsFunction.debounce((e) => {
        const { currentMarket } = this.state
        const { language } = this.props
        const params = {
            keywords: e.target.value.trim(),
            realm: 'instrument',
            language: Converter.mappingWinVestLanguage(language.lang),
            size: 50
        }
        if (e.target.value) {
            this.props.searchSystemService(params, res => {
                if (res.status === SERVICES_RESP.STATUS_OK && Array.isArray(res.result.instrument.data) && res.result.instrument.data.length) {
                    const searchList = res.result.instrument.data.filter(item => item.market === currentMarket)
                    this.setState({ searchList, showSearchBlock: true })
                } else {
                    this.setState({ showSearchBlock: false })
                }
            })
        }
    }, 400)
}

VirtualTradingAreaLeft.defaultProps = {
    lotSize: 1,
}


export default connect(state => ({
    language: state.app.language,
    markets: state.trade.markets,
}),
    dispatch => ({
        searchSystemService: (p, res) => dispatch(forumActions.searchSystemAction(p, res)),
        getInstrumentDetail: (p, res) => dispatch(stockActions.getInstrumentDetailAction(p, res)),
        getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
    }))(VirtualTradingAreaLeft)